import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ContainerDash,  Scroll } from "../../styles/global";
import { P3Desk } from "../../styles/styles_text";
import { Button } from "../../components/ui/button";
import NumeroAvaliados from "./NumeroAvaliados";
import DonutChart from "./DonutChart";
import StackedBarChart from "./StackedBarChart";
import EvolutionChart from "./EvolutionChart";
import { useDispatch, useSelector } from "react-redux";
import { CalcAlteracoesEncontradas, CalcAntagonicos, CalcCompValoresReferencia, CalcContralaterais, FiltroTypes } from "./Funcs";
import AlteracoesEncontradas from "./AlteracoesEncontradas";
import HowWorks from "./HowWorks";
import ListNotes from "./ListNotes";
import { TypesErrorRequest, TypesLanguage } from "../../utils/types";
import TableHighPriority from "./TableHighPriorityCases";
import { TextsProps } from "../../database/txt.interface";
import {ReactComponent as Dots} from "../../assets/kinologyIcons/svg/dotthree.svg"
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import AddNote from "./AddNote";

import {ReactComponent as Plus}  from "../../assets/kinologyIcons/svg/plus.svg";
import {ReactComponent as Arrow}  from "../../assets/kinologyIcons/svg/arrow_drop.svg";
import {ReactComponent as Trash}  from "../../assets/kinologyIcons/svg/trash.svg";
import {ReactComponent as ShareCSV}  from "../../assets/kinologyIcons/svg/share_csv.svg";
import CreatePanel from "./CreatePanel";
import CustomizeFiltersPanel from "./CustomizeFiltersPanel";
import { DashBoardActions } from "../../store/ducks/dashboard";
import moment from "moment";
import ConfirmPanelDeletion from "./ConfirmPaneldeletion";
import ToastAlert from "../../components/toast";
import { AppActions } from "../../store/ducks/app";
import DeletePanelCreated from "./DeletePanel";
import { endOfMonth, endOfYear, format, startOfMonth, startOfYear } from "date-fns";
import * as PopoverPrimitive from "@radix-ui/react-popover";

interface TypeExecucoes {
	AGRUPAMENTO_TIPO: string;
	EXECUCAO_EXECMAX: string;
	EXECUCAO_EXECMED: string;
	EXECUCAO_EXECUTADA: string;
	EXECUCAO_MODO: string;
	EXECUCAO_PESOMIN: string;
	EXECUCAO_REPS: string;
	EXECUCAO_RM: number;
	EXECUCAO_TEMPO: string;
	EXECUCAO_TIPO: string;
	EXERCICIO_TITULO_EN: string;
	EXERCICIO_TITULO_ES: string;
	EXERCICIO_TITULO_PT: string;
	ID_AGRUPAMENTO: string;
	ID_EXECUCAO: string;
	ID_EXERCICIO: string;
	ID_USUARIO: string;
	VALOR_ESPERADO: string;
}

interface TypesAvaliacoesUnicas {
	AVALIACAO_FINALIZADA_ATUALIZADA: string;
	AVALIACAO_FINALIZADA_CRIADO: string;
	AVALIACAO_FINALIZADA_EXCLUIDO: string;
	EXECUCOES: Array<TypeExecucoes>;
	IDS_EXECUCOES: string;
	ID_AVALIACAO_FINALIZADA: string;
	ID_EXERCICIO: string;
	ID_PROTOCOLO: string;
	ID_USUARIO: string;
	ID_USUARIO_AVALIADOR: string;
	USUARIO_LADO_DOMINANTE: string;
}

interface TypesPacientesAvaliados {
	ID_USUARIO: number;
	USUARIO_NOME: string;
	PROTOCOLOS: Array<any>
	AVALIACOES: Array<TypesAvaliacoesUnicas>;
}

export interface TypesAvaliacoesDynalabs {
	code: number;
	message: string;
	pacientes_avaliados: Array<TypesPacientesAvaliados>;
}

interface TypeAssimetrias {
	ID_USUARIO: number;
	USUARIO_NOME: string;
	ID_CARGO: number;
	LEGENDAS: Array<{
		INFERIOR_DORSAL: any;
		INFERIOR_FRONTAL: any;
		SUPERIOR_DORSAL: any;
		SUPERIOR_FRONTAL: any;
	}>;
	LISTAS: Array<{
		INFERIOR_DORSAL: [];
		INFERIOR_FRONTAL: [];
		SUPERIOR_DORSAL: [];
		SUPERIOR_FRONTAL: [];
	}>;
	RELACOES_REFERENCIAIS: Array<any>;
}

interface TypesAssimetriasDynalabs {
	code: number;
	message: string;
	assimetrias: Array<TypeAssimetrias>;
};

export interface panelCreatedProps {
	txDataHora: string;
	FILTRO_DASH_NOME: string;
	filtro: FiltroTypes,
	visualizacao: string[];
	filterID?:number;
};

export interface panelsSaved {

	FILTRO_DASH_ATUALIZADO: string;
	FILTRO_DASH_CRIADO: string;
	FILTRO_DASH_NOME: string;
	FILTRO_DASH_VALORES:FiltroTypes;
	ID_FILTRO: string;
}

type KeyMonth = {
	[key:string] : string
}

const DashDynaLabs: React.FC = () => {

	const dispatch = useDispatch();

	const language = useSelector((state: any) => state.configs.language);

	const assimetrias_dynalabs: any = useSelector(
		(state: any) => state.dashboard.assimetrias_dynalabs
	);

	const panelsSaved: Array<panelsSaved>  = useSelector(
		(state: any) => state.dashboard.data_panels_saved
	);
	const loadSaveNewPanel: boolean  = useSelector(
		(state: any) => state.dashboard.load_new_panel_dash_dynalabs
	);
	const avaliacoes_dynalabs: TypesAvaliacoesDynalabs = useSelector(
		(state: any) => state.dashboard.avaliacoes_dynalabs
	);
	const cargos_dynalabs = useSelector(
		(state: any) => state.dashboard.cargos
	);

	const protocolos_dynalabs = useSelector(
		(state: any) => state.manage_protocol.protocolos
	);
	const current_language: TextsProps = useSelector((state: any) => state.configs.current_language);

	const mesesAbreviados = [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	];
	const meses:KeyMonth = {
		Jan: "Janeiro",
		Feb: "Fevereiro",
		Mar: "Março",
		Apr: "Abril",
		May: "Maio",
		Jun: "Junho",
		Jul: "Julho",
		Aug: "Agosto",
		Sep: "Setembro",
		Oct: "Outubro",
		Nov: "Novembro",
		Dec: "Dezembro",
	};

	const is_open_toast = useSelector((state: any) => state.app.is_open_toast);
	const creatingNewDash = useSelector((state:any)=> state.dashboard.creating_new_dash);
	const panelDeleted = useSelector((state:any)=> state.dashboard.panel_has_deleted);
	const loadDownloadCSV = useSelector((state:any)=> state.dashboard.load_request_export_excel);


	const [panelModal, setPanelModal] = useState(false);
	const [customPanel, setCustomPanel] = useState(false);
	const [editCurstomPanel, setEditCustomPanel] = useState(false);
	const [clearAllFilters, setClearAllFilters] = useState(false);
	const [footerPanel, setFooterPanel] = useState(false);
	const [newPanel, setNewPanel] = useState<panelCreatedProps[]>([]);
	const [createdPanel, setCreatedPanel] = useState<panelsSaved[]>([]);
	const [arrowVisible, setArrowVisible] = useState<boolean>(false);
	const [modalDeletePanel, setModalDeletePanel] = useState<boolean>(false);
	const [numero_avaliados, set_numero_avaliados] = useState(0);
	const [openPopover, setOpenPopover] = useState(false);


	const ano_atual = new Date().getFullYear();

	const getLastThreeMonthsAbbr = () => mesesAbreviados
		.map((m, i, a) => a[(new Date().getMonth() - 2 + i + 12) % 12]).slice(0, 3);

	const [current_selected_panel, set_current_selected_panel] = useState(getLastThreeMonthsAbbr().reverse()[0]);
	

	useEffect(()=>{
		dispatch(DashBoardActions.set_current_selected_panel(current_selected_panel))
	},[current_selected_panel]);
	
	useEffect(()=>{
		setCreatedPanel(panelsSaved);
		setFooterPanel(false)
		setEditCustomPanel(false)
		setNewPanel([])
		setModalDeletePanel(false)

	},[panelsSaved]);

	useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (newPanel.length > 0 || editCurstomPanel) {
        event.preventDefault(); 
        dispatch(DashBoardActions.set_modal_delete_panel_created(true))
        window.history.pushState(null, '', window.location.href); 
      }
    };

    window.addEventListener('popstate', handlePopState);

    if (newPanel.length > 0) {
      window.history.pushState(null, '', window.location.href);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [newPanel, editCurstomPanel]);
	
	useEffect(()=>{
		if(footerPanel){
			dispatch(DashBoardActions.set_creating_new_dashboard(true))
		}else{
			dispatch(DashBoardActions.set_creating_new_dashboard(false))
		}
	},[footerPanel])

	useEffect(()=>{
		if(panelDeleted){

			setCurrentPanel(getLastThreeMonthsAbbr().reverse()[0])
			set_current_selected_panel(getLastThreeMonthsAbbr().reverse()[0])
			dispatch(DashBoardActions.success_deleted_panel(false));
			dispatch(DashBoardActions.panel_has_deleted(false));
		}

	},[panelDeleted])


	const meses_traducoes: any = {
		Jan: { pt: "Jan", es: "Ene" },
		Feb: { pt: "Fev", es: "Feb" },
		Mar: { pt: "Mar", es: "Mar" },
		Apr: { pt: "Abr", es: "Abr" },
		May: { pt: "Mai", es: "May" },
		Jun: { pt: "Jun", es: "Jun" },
		Jul: { pt: "Jul", es: "Jul" },
		Aug: { pt: "Ago", es: "Ago" },
		Sep: { pt: "Set", es: "Sep" },
		Oct: { pt: "Out", es: "Oct" },
		Nov: { pt: "Nov", es: "Nov" },
		Dec: { pt: "Dez", es: "Dic" }
	};


	
	function GenerateNumeroAvaliados() {
		if (avaliacoes_dynalabs?.pacientes_avaliados?.length > 0) {
			set_numero_avaliados(avaliacoes_dynalabs?.pacientes_avaliados?.length);
		}
	}

	const [risco_cargo, set_risco_cargo]: any = useState([]);
	const [default_risco_cargo, set_default_risco_cargo]: any = useState([]);
	function GenerateRiscoCargo(filtros?: any) {

		set_default_risco_cargo(filtros)
		const indicadores_contralaterais_cargo = CalcContralaterais(assimetrias_dynalabs, filtros ? filtros : {});

		const order_by_cargos = cargos_dynalabs.map((cargo: any) => {
			const usuarios = indicadores_contralaterais_cargo?.map((risco: any) => { return risco.usuarios }).flat()
			return usuarios?.filter((user: any) => Number(user.cargo) === Number(cargo.ID_CARGO)).flat();
		})

		const order_by_cargos_clear = order_by_cargos.filter((subarray: any) => subarray.length > 0);

		const order_by_cargos_riscos = order_by_cargos_clear.map((risco: any) => {
			const baixo_risco = risco.filter((user: any) => user.resultado == "POSITIVO")
			const medio_risco = risco.filter((user: any) => user.resultado == "INTERMEDIARIO")
			const alto_risco_1 = risco.filter((user: any) => user.resultado == "NEGATIVO_1")
			const alto_risco_2 = risco.filter((user: any) => user.resultado == "NEGATIVO_2")
			const nome_cargo = cargos_dynalabs.filter((cargo: any) => cargo.ID_CARGO == Number(risco[0].cargo))[0].CARGO_TITULO

			return {
				eixo_x: nome_cargo,
				baixo_risco: baixo_risco.length,
				medio_risco: medio_risco.length,
				alto_risco_1: alto_risco_1.length,
				alto_risco_2: alto_risco_2.length,
				baixo_risco_users: baixo_risco,
				medio_risco_users: medio_risco,
				alto_risco_users_1: alto_risco_1,
				alto_risco_users_2: alto_risco_2,
				usuarios: risco.user_nome,
				total: risco.length,
			}
		})

		set_risco_cargo(order_by_cargos_riscos);
	}

	const [risco_protocolo, set_risco_protocolo]: any = useState([]);
	const [default_risco_protocolo, set_default_risco_protocolo]: any = useState([]);
	function GenerateRiscoProtocolo(filtros?: any) {
		set_default_risco_protocolo(filtros);
		if (protocolos_dynalabs.length > 0 && assimetrias_dynalabs.code === 0) {
			const chart_data = protocolos_dynalabs.map((protocolo: any) => {
				filtros.protocolo = [protocolo.ID_PROTOCOLO]
				const resultado: any = CalcContralaterais(assimetrias_dynalabs, filtros)
				if (resultado[0]?.valor_risco > 0 || resultado[1]?.valor_risco > 0 || resultado[2]?.valor_risco > 0) {
					return {
						eixo_x: protocolo.PROTOCOLO_TITULO_PT,
						baixo_risco: resultado[0]?.valor_risco,
						medio_risco: resultado[1]?.valor_risco,
						alto_risco_1: resultado[2]?.valor_risco,
						alto_risco_2: resultado[3]?.valor_risco,
						baixo_risco_users: resultado[0]?.usuarios,
						medio_risco_users: resultado[1]?.usuarios,
						alto_risco_users_1: resultado[2]?.usuarios,
						alto_risco_users_2: resultado[3]?.usuarios,
					}
				}
			})
			const filtrado = chart_data.filter((item: any) => item !== undefined);
			set_risco_protocolo(filtrado)
		}
	}

	const [evolucao_alteracoes_encontradas, set_evolucao_alteracoes_encontradas]: any = useState([]);
	function GenerateEvolucaoAlteracoesEncontradas() {

		const mesAtual = new Date().getMonth();
		const mesesAbreviadosFiltrados = mesesAbreviados.slice(0, mesAtual + 1);

		const chart_data = mesesAbreviadosFiltrados.map((mes: string) => {
			const dados_mes: any = CalcAlteracoesEncontradas(assimetrias_dynalabs, { ano: ano_atual, mes: mes })

			if (dados_mes != undefined) {
				return {
					month: mes,
					baixo_risco: dados_mes[0].usuarios.length,
					medio_risco: dados_mes[1].usuarios.length,
					alto_risco_1: dados_mes[2].usuarios.length,
					alto_risco_2: dados_mes[3].usuarios.length,
					baixo_risco_users: dados_mes[0].usuarios,
					medio_risco_users: dados_mes[1].usuarios,
					alto_risco_users_1: dados_mes[2].usuarios,
					alto_risco_users_2: dados_mes[3].usuarios,
				}
			}
		})
		if (chart_data[0] != undefined && chart_data != undefined) {
			set_evolucao_alteracoes_encontradas(chart_data)
		}

	}

	const [alteracoes_encontradas, set_alteracoes_encontradas]: any = useState([])
	const [default_filter_alteracoes_encontradas, set_default_filter_alteracoes_encontradas]: any = useState([]);

	

	const HandlerFiltersForGraphc = (filtroComValores:any)=>{

		const filtroForAlteracoes = { ...filtroComValores };
		const filtroForContralaterais = { ...filtroComValores };
		const filtroForAntagonicos = { ...filtroComValores };
		const CompValoresReferencia = { ...filtroComValores };
		const ContRiscoProtocolo = { ...filtroComValores };
		const ContRiscoCargo = { ...filtroComValores };

		if(filtroForContralaterais?.articulacao){	delete filtroForContralaterais?.articulacao	}
		if(CompValoresReferencia?.articulacao){	delete CompValoresReferencia?.articulacao	}
		if(ContRiscoProtocolo?.articulacao){	delete ContRiscoProtocolo?.articulacao	}
		if(ContRiscoCargo?.articulacao){	delete ContRiscoCargo?.articulacao	}

		if(filtroForContralaterais?.alteracoes){ delete filtroForContralaterais?.alteracoes	}
		if(filtroForAntagonicos?.alteracoes ) { delete filtroForAntagonicos?.alteracoes }
		if(CompValoresReferencia?.alteracoes){	delete CompValoresReferencia?.alteracoes	}

		if(filtroForAntagonicos?.protocolo ) {delete filtroForAntagonicos?.protocolo }
		if(filtroForAntagonicos?.exercicio ) {delete filtroForAntagonicos?.exercicio }

		GenerateAlteracoesEncontradas(filtroForAlteracoes)

		GenerateIndicadoresContralaterais(filtroForContralaterais)

		GenerateIndicadoresAntagonicos(filtroForAntagonicos)

		GenerateCompValoresReferencia(CompValoresReferencia)

		GenerateRiscoProtocolo(ContRiscoProtocolo)

		GenerateRiscoCargo(ContRiscoCargo)
	};

	const SetFiltersInNewCustomPanel = ()=> {
		const currentPanel = newPanel?.find((panel)=> panel?.FILTRO_DASH_NOME == current_selected_panel);

		const hasAnyFiltroValue = (() => {
			const filtro = currentPanel?.filtro;
			if (!filtro) return false;

			return Object.entries(filtro).some(([key, value]) => {
				if (key === "data") {
					return value && (value.from || value.to);
				}
			
				return Array.isArray(value) && value.length > 0;
			});
		})();

	
		const filtroComValores = Object.fromEntries(
			Object.entries(currentPanel?.filtro || {}).filter(([key, value]) => {
				if (key === "data") {
					return value && (value.from || value.to);
				}
				return Array.isArray(value) && value.length > 0;
			})
		);

		if( hasAnyFiltroValue ){
			HandlerFiltersForGraphc(filtroComValores)
		}
	}

	useEffect(()=>{
		if(newPanel.length > 0){
			SetFiltersInNewCustomPanel()
		}
	},[newPanel]);

	
	const findCreatedPanelSelected = createdPanel?.find((panel)=> panel.FILTRO_DASH_NOME === current_selected_panel );
	


	useEffect(()=>{

		const hasAnyFiltroValue = (() => {
			const filtro = findCreatedPanelSelected?.FILTRO_DASH_VALORES;
			if (!filtro) return false;

			return Object.entries(filtro).some(([key, value]) => {
				if (key === "data") {
					return value && (value.from || value.to);
				}
			
				return Array.isArray(value) && value.length > 0;
			});
		})();

	
		const filtroComValores = Object.fromEntries(
			Object.entries(findCreatedPanelSelected?.FILTRO_DASH_VALORES || {}).filter(([key, value]) => {
				if (key === "data") {
					return value && (value.from || value.to);
				}
				return Array.isArray(value) && value.length > 0;
			})
		);

		if(hasAnyFiltroValue){
			HandlerFiltersForGraphc(filtroComValores)
		}

	},[current_selected_panel, createdPanel])
	

	function GenerateAlteracoesEncontradas(filtros?: any) {
		set_default_filter_alteracoes_encontradas(filtros);
		const resultado = CalcAlteracoesEncontradas(assimetrias_dynalabs, filtros ? filtros : {});
		set_alteracoes_encontradas(resultado)
	}



	//Contralaterais
	const [indicadores_contralaterais, set_indicadores_contralaterais]: any = useState([]);
	const [default_filter_contralaterais, set_default_filter_contralaterais]: any = useState({});

	function GenerateIndicadoresContralaterais(filtros?: any) {

		set_default_filter_contralaterais(filtros)
		const resultado: any = CalcContralaterais(assimetrias_dynalabs, filtros ? filtros : {});

		//Agrupa users Alto risco e Alto risco 2 
		resultado.push({
			fill: "#D12600",
			name_risco: "Alto risco",
			usuarios: [resultado[2].usuarios, resultado[3].usuarios].flat(),
			valor_risco: [resultado[2].usuarios, resultado[3].usuarios].flat().length,
		})
		delete resultado[2]
		delete resultado[3]

		if (resultado != undefined) {
			set_indicadores_contralaterais(resultado);
		}
	}

	const [evolucao_indicadores_contralaterais, set_evolucao_indicadores_contralaterais]: any = useState([]);
	function GenerateEvolucaoIndicadoresContralaterais() {

		const mesAtual = new Date().getMonth();
		const mesesAbreviadosFiltrados = mesesAbreviados.slice(0, mesAtual + 1);

		const chart_data = mesesAbreviadosFiltrados.map((mes: string) => {
			const dados_mes: any = CalcContralaterais(assimetrias_dynalabs, { ano: ano_atual, mes: mes })

			if (dados_mes != undefined) {
				return {
					month: mes,
					baixo_risco: dados_mes[0].usuarios.length,
					medio_risco: dados_mes[1].usuarios.length,
					alto_risco_2: [dados_mes[2].usuarios, dados_mes[3].usuarios].flat().length,
					baixo_risco_users: dados_mes[0].usuarios,
					medio_risco_users: dados_mes[1].usuarios,
					alto_risco_users_2: [dados_mes[2].usuarios, dados_mes[3].usuarios].flat(),
				}
			}
		})
		if (chart_data[0] != undefined && chart_data != undefined) {
			set_evolucao_indicadores_contralaterais(chart_data)
		}

	}

	

	//Antagonicos
	const [indicadores_antagonicos, set_indicadores_antagonicos]: any = useState([]);
	const [default_filter_antagonicos, set_default_filter_antagonicos]: any = useState([]);
	function GenerateIndicadoresAntagonicos(filtros?: any) {
		set_default_filter_antagonicos(filtros)
		const resultado = CalcAntagonicos(assimetrias_dynalabs, filtros ? filtros : {});
		if (resultado != undefined) {
			set_indicadores_antagonicos(resultado);
		}
	}

	const [evolucao_indicadores_antagonicos, set_evolucao_indicadores_antagonicos]: any = useState([]);
	function GenerateEvolucaoIndicadoresAntagonicos() {
		const mesAtual = new Date().getMonth();
		const mesesAbreviadosFiltrados = mesesAbreviados.slice(0, mesAtual + 1);

		const chart_data = mesesAbreviadosFiltrados.map((mes: string) => {
			const dados_mes: any = CalcAntagonicos(assimetrias_dynalabs, { ano: ano_atual, mes: mes })

			if (dados_mes != undefined) {
				return {
					month: mes,
					baixo_risco: dados_mes[0].usuarios.length,
					alto_risco_2: dados_mes[1].usuarios.length,
					medio_risco: dados_mes[2].usuarios.length,
					baixo_risco_users: dados_mes[0].usuarios,
					alto_risco_users_2: dados_mes[1].usuarios,
					medio_risco_users: dados_mes[2].usuarios,
				}
			}
		})
		if (chart_data[0] != undefined && chart_data != undefined) {
			set_evolucao_indicadores_antagonicos(chart_data)
		}

	}

	//Comparação de referencias

	const [comparacao_valores_referencia, set_comparacao_valores_referencia]: any = useState([]);
	const [default_filter_valores_referencia, set_default_filter_valores_referencia]: any = useState([]);
	function GenerateCompValoresReferencia(filtros?: any) {
		set_default_filter_valores_referencia(filtros)
		if (avaliacoes_dynalabs.code === 0) {
			const resultado = CalcCompValoresReferencia(avaliacoes_dynalabs, filtros ? filtros : {});
			set_comparacao_valores_referencia(resultado);
		}
	}
	const [evolucao_comparacao_valores_referencia, set_evolucao_comparacao_valores_referencia]: any = useState([]);
	function GenerateEvolucaoCompValoresReferencia() {
		const mesAtual = new Date().getMonth();
		const mesesAbreviadosFiltrados = mesesAbreviados.slice(0, mesAtual + 1);

		if (avaliacoes_dynalabs.code === 0) {
			const chart_data = mesesAbreviadosFiltrados.map((mes: string) => {
				const dados_mes: any = CalcCompValoresReferencia(avaliacoes_dynalabs, { ano: ano_atual, mes: mes })
				if (dados_mes != undefined) {
					return {
						month: mes,
						baixo_risco: dados_mes[0].usuarios.length,
						alto_risco_2: dados_mes[1].usuarios.length,
						medio_risco: dados_mes[2].usuarios.length,
						baixo_risco_users: dados_mes[0].usuarios,
						medio_risco_users: dados_mes[2].usuarios,
						alto_risco_users_2: dados_mes[1].usuarios,
					}
				}
			})
			if (chart_data[0] != undefined && chart_data != undefined) {
				set_evolucao_comparacao_valores_referencia(chart_data)
			}
		}
	}


	const setCurrentPanel = (item: any) => {

		set_current_selected_panel(item);

		GenerateIndicadoresContralaterais({ ano: ano_atual, mes: item });
		GenerateIndicadoresAntagonicos({ ano: ano_atual, mes: item });
		GenerateCompValoresReferencia({ ano: ano_atual, mes: item });
		GenerateAlteracoesEncontradas({ ano: ano_atual, mes: item });
		GenerateRiscoProtocolo({ ano: ano_atual, mes: item });
		GenerateRiscoCargo({ ano: ano_atual, mes: item });
	}

	useEffect(() => {
		GenerateEvolucaoIndicadoresContralaterais();
		GenerateEvolucaoIndicadoresAntagonicos();
		GenerateEvolucaoCompValoresReferencia();
		GenerateEvolucaoAlteracoesEncontradas();
		GenerateNumeroAvaliados();
		setCurrentPanel(current_selected_panel)
	}, []);

	 const scrollRef = useRef<HTMLDivElement>(null);

	const [scrollInterval, setScrollInterval] = useState<NodeJS.Timeout | null>(null);

  const startScrollingRight = () => {
    const interval = setInterval(() => {
      scrollRef.current?.scrollBy({ left: 10, behavior: "auto" });
    }, 16);
    setScrollInterval(interval);
  };
  const startScrollingLeft = () => {
    const interval = setInterval(() => {
      scrollRef.current?.scrollBy({ left: -10, behavior: "auto" });
    }, 16);
    setScrollInterval(interval);
  };

  const stopScrolling = () => {
    if (scrollInterval) {
      clearInterval(scrollInterval);
      setScrollInterval(null);
    }
  };


	useEffect(() => {
		const container = scrollRef.current;
		if (!container) return;

		const checkOverflow = () => {
			const hasOverflow = container.scrollWidth > container.clientWidth;
			setArrowVisible(hasOverflow)
		};

		checkOverflow();
		window.addEventListener("resize", checkOverflow);

		return () => window.removeEventListener("resize", checkOverflow);
	}, [panelsSaved, newPanel]);

	const getDataPanelForEdit = ()=> {
		const panelIndex = createdPanel.findIndex(
			panel => panel.FILTRO_DASH_NOME === current_selected_panel
		);
		const panelToUpdate = createdPanel[panelIndex];
		const transformedPanel = {
			txDataHora:  moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),// ou outra string que você queira
			FILTRO_DASH_NOME: panelToUpdate.FILTRO_DASH_NOME,
			filtro: panelToUpdate.FILTRO_DASH_VALORES,
			visualizacao: [],
			ID_FILTRO: Number(panelToUpdate.ID_FILTRO),
		};

		return transformedPanel;
	};

	const handlerDownloadCSV = ()=>{

		const customPeriod = `${findCreatedPanelSelected?.FILTRO_DASH_VALORES?.data?.from?.split('T')[0]}/${findCreatedPanelSelected?.FILTRO_DASH_VALORES?.data?.to?.split('T')[0]}`

		const mesIndex = mesesAbreviados.findIndex(m => m.toLowerCase() === current_selected_panel.toLowerCase());

		const start = current_selected_panel == 'anual' ? format(startOfYear(new Date(ano_atual, 0)), "yyyy-MM-dd") : format(startOfMonth(new Date(ano_atual, mesIndex)), "yyyy-MM-dd")
		const end = current_selected_panel == 'anual' ? format(endOfYear(new Date(ano_atual, 0)), "yyyy-MM-dd") : format(endOfMonth(new Date(ano_atual, mesIndex)), "yyyy-MM-dd")

		const DefaultPeriod = `${start}/${end}`;

		const PanelId = createdPanel.find((panel)=> panel.FILTRO_DASH_NOME == current_selected_panel )?.ID_FILTRO

		const data = {
			txDash: current_selected_panel == 'anual' ? 'anual' : meses[current_selected_panel] ?? current_selected_panel,
			txPeriodo:  ( meses[current_selected_panel] || current_selected_panel == 'anual') ? DefaultPeriod : customPeriod ,
			ID_FILTRO: PanelId ? Number(PanelId) : 0
		}

		dispatch(DashBoardActions.set_request_export_excel_dash(data))
		dispatch(DashBoardActions.set_load_request_export_excel_dash(true))

	};

	useEffect(()=>{
		if(!loadDownloadCSV){
			 setOpenPopover(false);
		}
	},[loadDownloadCSV])


	return (
		<ContainerDash className={`overflow-x-hidden`} style={{ backgroundColor: "#F1F2F3", }}>
				{is_open_toast && <ToastAlert />}
			<Frame 
				style={{
					height: "100%",
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Cabecalho style={{ width: '60%',  }} >
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							justifyContent: "center",
							width: '100%',
						}}
					>
						<h1 style={{ color: '#63677A', fontSize: '1.5rem' }}>
							{
								newPanel.length > 0
								? 'Criar Painel'
								: 'Dashboard Dynalab'
							}
							
						</h1>

					</div>
					<div className={`w-[90%] flex flex-row mt-6 mb-4 justify-between relative items-center`}	>
						<div 
							className={`
								flex h-full w-10  cursor-pointer items-center justify-center
								${arrowVisible ? `flex` : `hidden`}
								${editCurstomPanel && `pointer-events-none`}
							`}
							onMouseDown={startScrollingLeft}
							onMouseUp={stopScrolling}
							onMouseLeave={stopScrolling}
						>
							<Arrow className={`  h-6 w-6 rotate-90`} color={`${editCurstomPanel ? `#9497A4`:`#000E4B`}`}/>
						</div>
						<div className="relative w-full">
								<div 
									ref={scrollRef}
									className={`flex flex-row w-full pb-1 overflow-x-auto scrollbar-none`}
								>
									{

										<Button
											onClick={() => setPanelModal(true)}
											className={`${(newPanel.length > 0 || editCurstomPanel ) ? `hidden` : `flex`} flex-row	ml-3 bg-transparent 	text-[#3D4259]	py-2 	px-4 	rounded-full 	border-2 	border-[#ABADB7] text-sm	font-medium 	hover:bg-[#C1FEE840] 	hover:text-[#005760] hover:border-[#005760]	active:bg-[#C1FEE860] active:text-[#005760]	active:border-[#005760]	transition-colors 	duration-200 mr-4	`}
										>
											{<Plus className={`hover:bg-[#C1FEE840] active:bg-[#C1FEE860] `}/>	}
											{'Criar painel'}

										</Button>
									}
									{
										newPanel?.map((item, index)=>(
											<div
												key={index}
												onClick={() => { set_current_selected_panel(item.FILTRO_DASH_NOME)}}
												className={`
													inline-flex
													items-center
													justify-center
													px-4 py-2 
													rounded-full 
													border-none 
													text-sm font-medium 
													cursor-pointer 
													transition-all
													whitespace-nowrap
													mr-4
													${item?.FILTRO_DASH_NOME === current_selected_panel 
														? 'bg-[#00A377] text-white' 
														: 'bg-[#CEF6E7] text-[#000E4B]'
													}
												`}	
											>
												{item?.FILTRO_DASH_NOME}
											</div>
										))
									}
									{
										createdPanel?.map((item, index)=>(
											<div
												key={index}
												onClick={() => {
													set_current_selected_panel(item.FILTRO_DASH_NOME);
													setCustomPanel(true)
													setEditCustomPanel(false)
												}}
												className={`
													inline-flex
													items-center
													justify-center
													px-4 py-2 
													rounded-full 
													border-none 
													text-sm font-medium 
													cursor-pointer 
													transition-all
													whitespace-nowrap
													mr-4
													${item?.FILTRO_DASH_NOME === current_selected_panel 
														? 'bg-[#00A377] text-white' 
														: 'bg-[#CEF6E7] text-[#000E4B]'
													}
													${editCurstomPanel &&  item?.FILTRO_DASH_NOME !== current_selected_panel && `bg-[#DEDFE3] text-[#9497A4] pointer-events-none`	}
												`}	
											>
												{item?.FILTRO_DASH_NOME}
											</div>
										))
									}
									{getLastThreeMonthsAbbr().reverse().map((item: string, index) => (
										<div
											key={index}
											onClick={() => {setCurrentPanel(item), 	setCustomPanel(false)}}
											className={`
													px-4 py-2 
													rounded-full 
													border-none 
													text-sm font-medium 
													cursor-pointer 
													mr-4
													${ item ==  current_selected_panel 
														? 'bg-[#00A377] text-white' 
														: 'bg-[#CEF6E7] text-[#000E4B]'
													}
													${editCurstomPanel && `bg-[#DEDFE3] text-[#9497A4] pointer-events-none`	}
												`}	
										>
											{language == TypesLanguage.PT ? meses_traducoes[item]?.pt :
												language == TypesLanguage.ES ? meses_traducoes[item]?.es :
													meses_traducoes[item]
											}/{ano_atual}

										</div>
									))}
									<Button
										onClick={() => set_current_selected_panel("anual")}
										className={`
											inline-block
											px-4 py-2 
											rounded-full 
											border-none 
											text-sm font-medium 
											cursor-pointer 
											mr-4
											${current_selected_panel === "anual" 
												? "bg-[#00A377] text-white" 
												: "bg-[#CEF6E7] text-[#000E4B]"
											}
											${editCurstomPanel && `bg-[#DEDFE3] text-[#9497A4] pointer-events-none`	}
										`}
									>
										Linha do tempo anual

									</Button>
								</div>
						</div>
							{arrowVisible && (
								<div className="absolute pb-1 -right-6 top-0 h-9 w-10 pointer-events-none bg-gradient-to-l from-[#F1F2F3] to-transparent z-10" />
							)}
							{arrowVisible && (
								<div className="absolute left-5 top-0 h-9 w-10 pointer-events-none bg-gradient-to-r from-[#F1F2F3] to-transparent z-10" />
							)}
						<div 
							className={`
								flex h-full w-10  cursor-pointer items-center justify-center
								${arrowVisible ? `flex` : `hidden`}
								${editCurstomPanel && `pointer-events-none`}
							`}
							onMouseDown={startScrollingRight}
							onMouseUp={stopScrolling}
							onMouseLeave={stopScrolling}
						>
							<Arrow className={`h-6 w-6 -rotate-90`} color={`${editCurstomPanel ? `#9497A4`:`#000E4B`}`}/>
						</div>

						<div className={`ml-5`}>
							<PopoverPrimitive.Root open={openPopover} onOpenChange={setOpenPopover}>
								<PopoverTrigger  className={`${editCurstomPanel ? `pointer-events-none` : `cursor-pointer`	}`}>
									<Dots color={`${editCurstomPanel ? `#9497A4`:`#000E4B`}`} />
								</PopoverTrigger>
								<PopoverContent className="bg-white rounded-[12px] px-0" align="end">
									<AddNote type={"popover"} style="w-full px-2 py-1.5 hover:bg-[#C4C5CC] active:bg-[#ABADB7]" />
									<div className={`${!!findCreatedPanelSelected ? `flex flex-row` : `hidden`  } px-2 py-0 w-full items-center cursor-pointer mt-2  hover:bg-[#C4C5CC] active:bg-[#ABADB7]`}
										onClick={()=> setModalDeletePanel(true)}
									>
										<Trash className={`-ml-2 w-[35px] h-[35px] `} color={`#141622`} />
										<p className={`text-[#3D4259] font-[500] -ml-1`}>Excluir painel</p>
									</div>
									<div className={`flex w-full items-center cursor-pointer mt-2 px-2 py-1.5 hover:bg-[#C4C5CC] active:bg-[#ABADB7]`}
										onClick={()=> handlerDownloadCSV()}
									>
										<ShareCSV className={` w-[20px] h-[20px] `}  color={`#141622`} />
										<p className={`text-[#3D4259] font-[500] ml-1`}>Exportar planilha</p>
										<div className={`${!loadDownloadCSV ?  `hidden` : ` flex`} items-center justify-center h-4 ml-3 `} >
											<div className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-solid border-[#000E4B] border-t-transparent"></div>
										</div>
									</div>
								</PopoverContent>
							
							</PopoverPrimitive.Root >
						</div>
					</div>
				</Cabecalho>
				<CreatePanel 
					close={()=>{setPanelModal(false)}}
					newPanel={(newPanelData)=>{
						setNewPanel((prev)=>[...prev, newPanelData]), 
						setCustomPanel(true),
						setEditCustomPanel(true)
						setFooterPanel(true)
						setClearAllFilters(true)
						setTimeout(()=>{setClearAllFilters(false)},500)
						set_current_selected_panel(newPanelData?.FILTRO_DASH_NOME)
					}}
					openPanel={panelModal}
				/>
		
				<Scroll style={{
					paddingBottom: "10rem",
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}>
					
					<div style={{ width: '60%', }}>


						{current_selected_panel != "anual" &&
							<>
							<div className={`flex flex-col`}>
								{
									!customPanel && (
										<>
											<P3Desk
												style={{ marginTop: "1rem", fontSize: "1.2rem", color: "#9497A4", fontWeight: '300' }}
											>
												Análise de risco mensal - {
													language == TypesLanguage.PT ? meses_traducoes[current_selected_panel]?.pt :
														language == TypesLanguage.ES ? meses_traducoes[current_selected_panel]?.es :
															meses_traducoes[current_selected_panel]
												}/{ano_atual}
											</P3Desk>
										</>
									)
								}
								{ (!editCurstomPanel && newPanel.length == 0 ) &&
										<HowWorks />
								}
							
							</div>

								<CustomizeFiltersPanel 
									customPanel={customPanel} 
									setEditPanel={()=> {
										setEditCustomPanel(true), 
										setFooterPanel(true)
										//Esse trecho limpa os filtros para poder adicionar novos na edição, pois são cumulativos.
										// setClearAllFilters(true)
										// setTimeout(()=>{setClearAllFilters(false)},500)
									}}
									editPanel={editCurstomPanel}
									clear={clearAllFilters}
									appliedFilters={findCreatedPanelSelected}
									defaultFilter={findCreatedPanelSelected?.FILTRO_DASH_VALORES}
									onFilterChange={(key, value)=> {
										if(newPanel.length > 0 ){
											setNewPanel(prev => {
												if (prev.length === 0) return prev;
	
												const lastPanel = prev.at(-1)!;
	
												const updatedPanel = {
													...lastPanel,
													filtro: {
														...lastPanel.filtro,
														[key]: value,
													},
												};
	
												const updatedArray = [...prev];
												updatedArray[updatedArray.length - 1] = updatedPanel;
												return updatedArray;
											});
											
										}else{

											setCreatedPanel(prev => {
												if (prev.length === 0) return prev;
	
												const panelIndex = prev.findIndex(
													panel => panel.FILTRO_DASH_NOME === current_selected_panel
												);
												if (panelIndex === -1) return prev;

												const panelToUpdate = prev[panelIndex];

												const updatedPanel = {
													...panelToUpdate,
													FILTRO_DASH_VALORES: {
														...panelToUpdate.FILTRO_DASH_VALORES,
														[key]: value,
													},
												};
												const updatedArray = [...prev];
												updatedArray[panelIndex] = updatedPanel;

												return updatedArray;
											});
												
										}
									}}
								/>
								<ConfirmPanelDeletion 
									close={()=>{dispatch(DashBoardActions.set_modal_delete_panel_created(false))}}
									isNewPanel={newPanel.length > 0 ? true : false}
									action={()=>{
										{
											newPanel.length > 0
											? [
													setNewPanel([]),  
													setFooterPanel(false),
													setCustomPanel(false),
													setEditCustomPanel(false),
													dispatch(DashBoardActions.set_modal_delete_panel_created(false)),
													setCurrentPanel(getLastThreeMonthsAbbr().reverse()[0]),
													set_current_selected_panel(getLastThreeMonthsAbbr().reverse()[0]),
													dispatch(
														AppActions.set_toast_visible({
															status_toast: true,
															type_toast: TypesErrorRequest.FAIL,
															message_toast: 'Painel Descartado',
														})
													)
												]
											: 	
												// Cancelar edição
												[
													setCreatedPanel(panelsSaved),
													setFooterPanel(false),
													setEditCustomPanel(false),
													dispatch(DashBoardActions.set_modal_delete_panel_created(false)),
												]
										}
									}}
								/>
								<DeletePanelCreated 
										close={()=>{setModalDeletePanel(false)}}
										action={()=>{
													setFooterPanel(false),
													setCustomPanel(false),
													setEditCustomPanel(false),
													dispatch(DashBoardActions.set_request_delete_panel_created_dashboard_dynalabs(
														{
															txDataHora: getDataPanelForEdit()?.txDataHora,
															ID_FILTRO: getDataPanelForEdit()?.ID_FILTRO
														}
													))
										}}
										open={modalDeletePanel}
								/>


								<div
									style={{
										display: "flex",
										flexDirection: "row",
										justifyContent: "space-between",
									}}
								>
									<AlteracoesEncontradas
										title="Alterações encontradas"
										data={alteracoes_encontradas}
										onDonutChange={GenerateAlteracoesEncontradas}
										defaultFilter={default_filter_alteracoes_encontradas}
										hiddenFilter={customPanel}
									/>

								</div>
								<div
									style={{
										display: "flex",
										flexDirection: "row",
										justifyContent: "space-between",
									}}
								>
									<DonutChart
										orientation="vertical"
										title="Indicadores Contralaterais"
										data={indicadores_contralaterais}
										onDonutChange={GenerateIndicadoresContralaterais}
										defaultFilter={default_filter_contralaterais}
										hiddenFilter={customPanel}
									/>
									<DonutChart
										orientation="vertical"
										title="Indicadores Antagônicos"
										data={indicadores_antagonicos}
										onDonutChange={GenerateIndicadoresAntagonicos}
										defaultFilter={default_filter_antagonicos}
										hiddenFilter={customPanel}
									/>
									<DonutChart
										orientation="vertical"
										title="Alteração comparado aos valores de referência"
										data={comparacao_valores_referencia}
										onDonutChange={GenerateCompValoresReferencia}
										defaultFilter={default_filter_valores_referencia}
										hiddenFilter={customPanel}
									/>
								</div>

								<StackedBarChart
									title="Contagem de risco por protocolo"
									labels={[
										{ label: "Sem alterações", color: "#00D084" },
										{ label: "Alterações leves", color: "#FFC530" },
										{ label: "Alterações significativas", color: "#E57E00" },
										{ label: "Alterações graves", color: "#D12600" },
									]}
									chartData={risco_protocolo}
									defaultFilter={default_risco_protocolo}
									onStackedChange={GenerateRiscoProtocolo}
									subtitle="Tempo médio: 48m"
									hiddenFilter={customPanel}
								/>

								<StackedBarChart
									title="Contagem de risco por cargo"
									labels={[
										{ label: "Sem alterações", color: "#00D084" },
										{ label: "Alterações leves", color: "#FFC530" },
										{ label: "Alterações significativas", color: "#E57E00" },
										{ label: "Alterações graves", color: "#D12600" },
									]}
									chartData={risco_cargo}
									defaultFilter={default_risco_cargo}
									onStackedChange={GenerateRiscoCargo}
									hiddenFilter={customPanel}
								/>
								<TableHighPriority
									title={current_language?.titulo_casos_alta_prioridade}
									defaultFilter={default_filter_alteracoes_encontradas}
									data={alteracoes_encontradas}
									onDonutChange={GenerateAlteracoesEncontradas}
									assimetrya={assimetrias_dynalabs}
									hiddenFilter={customPanel}
								/>
							</>
						}
						{current_selected_panel == "anual" &&
							<>
								<P3Desk style={{ marginTop: "1rem" }}>Linha do tempo anual</P3Desk>
								<NumeroAvaliados avaliados={numero_avaliados} />

								<EvolutionChart
									title="Alterações encontradas"
									chartData={evolucao_alteracoes_encontradas}
									labels={
										[
											{ label: "Sem alterações", color: "#00D084" },
											{ label: "Alterações leves", color: "#FFC530" },
											{ label: "Alterações significativas", color: "#E57E00" },
											{ label: "Alterações graves", color: "#D12600" },
										]
									}
									fills={{
										fill_baixo_risco: "#0CD100",
										fill_medio_risco: "#FFC530",
										fill_alto_risco_1: "#E57E00",
										fill_alto_risco_2: "#D12600"
									}}
								/>

								<EvolutionChart
									title="Indicadores Contralaterais"
									chartData={evolucao_indicadores_contralaterais}
									labels={
										[
											{ label: "Baixo risco", color: "#00D084" },
											{ label: "Médio risco", color: "#FFC530" },
											{ label: "Alto risco", color: "#D12600" },
										]
									}
									fills={{
										fill_baixo_risco: "#0CD100",
										fill_medio_risco: "#FFC530",
										fill_alto_risco_1: "#E57E00",
										fill_alto_risco_2: "#D12600"
									}}
								/>

								<EvolutionChart
									title="Indicadores Antagônicos"
									chartData={evolucao_indicadores_antagonicos}
									labels={
										[
											{ label: "NA", color: "#797D8D" },
											{ label: "Baixa chance de lesão", color: "#00D084" },
											{ label: "Há chance de lesão", color: "#D12600" },
										]
									}
									fills={{
										fill_baixo_risco: "#0CD100",
										fill_medio_risco: "#797D8D",
										fill_alto_risco_1: "#E57E00",
										fill_alto_risco_2: "#D12600"
									}}
								/>

								<EvolutionChart
									title="Alteração comparado aos valores de referência"
									chartData={evolucao_comparacao_valores_referencia}
									labels={
										[
											{ label: "NA", color: "#797D8D" },
											{ label: "Abaixo do esperado", color: "#D12600" },
											{ label: "Dentro do esperado", color: "#00D084" },
										]
									}
									fills={{
										fill_baixo_risco: "#0CD100",
										fill_medio_risco: "#797D8D",
										fill_alto_risco_1: "#E57E00",
										fill_alto_risco_2: "#D12600"
									}}
								/>
							</>
						}
						<ListNotes />
					</div>
				</Scroll>
			<div 
				className={`${footerPanel ? `flex` : `hidden`}  w-full justify-center  py-3 px-50 absolute bottom-0 bg-white z-20  shadow-[0_-1px_8px_0px_rgba(0,0,0,0.1)]`}
			>
							
				<div className={`flex w-2/3 justify-around `}>
						<Button
							className={`flex w-[48%] p-4 items-center border-2  rounded-md font-[Kanit-Regular] text-[#000E4B] border-[#A81F00] font-semibold cursor-pointer 
							
								`}
							onClick={()=> dispatch(DashBoardActions.set_modal_delete_panel_created(true))}
						>
							{
								newPanel.length > 0 
								?	'Cancelar painel'
								: 'Cancelar edição'
							}
						
						</Button>
						<Button className={`flex w-[48%] p-4 items-center  font-[Kanit-Regular] text-[#FAFAFA] font-bold bg-[#000E4B] border-[#000E4B] rounded-md cursor-pointer`}
							onClick={()=> {
								newPanel.length > 0 
								?[ dispatch(DashBoardActions.set_request_new_panel_dashboard_dynalabs(newPanel[0])), 
									// setClearAllFilters(true)
								]
								:[ 
									dispatch(DashBoardActions.set_request_edit_panel_created_dashboard_dynalabs(getDataPanelForEdit())), 
									
								]
							}}
						>
							{
								loadSaveNewPanel
								?	<div className="flex items-center justify-center h-4">
										<div className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-solid border-[#FAFAFA] border-t-transparent"></div>
									</div>

								:	'Salvar painel'
							}
						
						</Button>
				</div>
			</div>
			</Frame>
		</ContainerDash>
	);
};

const Frame = styled.div`
	width: 100%;
`;

const Cabecalho = styled.div`
	width: 100%;
	margin-top: 2rem;
`;

export default DashDynaLabs;
